import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@shared/lib';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(({ className, invalid, ...props }, ref) => (
  <input
    ref={ref}
    className={cn(
      'rounded-xl border bg-card px-4 py-3.5 text-sm text-fg outline-none transition-colors',
      'placeholder:text-muted-2',
      invalid ? 'border-danger focus:border-danger' : 'border-line focus:border-accent',
      className,
    )}
    {...props}
  />
));

Input.displayName = 'Input';
